'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidReduxReducer;
function randomType() {
  return '@@is-valid-redux-reducer/' + Math.random().toString(36).substring(7).split('').join('\\');
}

function isValidReduxReducer(reducer) {
  var throwError = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  if (typeof reducer !== 'function') {
    if (throwError) {
      throw new Error('Reducer must be a function.');
    } else {
      return false;
    }
  }

  var initialState = reducer(undefined, { type: randomType() });
  if (typeof initialState === 'undefined') {
    if (throwError) {
      throw new Error('Reducer must return the initial state if the state is undefined.');
    } else {
      return false;
    }
  }

  return true;
}